module.exports = __webpack_public_path__ + "static/media/poster_wide_l1.0e01ae8b.png";